const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnergyConsume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 28.9189V34.074",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 13.1149V25.3378",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 28.2675V26.2998C6.26562 25.1219 7.22012 24.1674 8.3981 24.1674H11.8525C13.0304 24.1674 13.9849 23.2129 13.9849 22.0349V20.4781",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7356 27.1369V26.084C33.7356 24.9022 32.7754 23.9477 31.5955 23.9515L26.1488 23.9742C24.9671 23.9799 24.0088 23.0235 24.0088 21.8418V18.5957",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7352 30.7011C34.7195 30.7011 35.5173 29.9032 35.5173 28.919C35.5173 27.9347 34.7195 27.1368 33.7352 27.1368C32.751 27.1368 31.9531 27.9347 31.9531 28.919C31.9531 29.9032 32.751 30.7011 33.7352 30.7011Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3231 31.9397C26.3074 31.9397 27.1052 31.1418 27.1052 30.1576C27.1052 29.1734 26.3074 28.3755 25.3231 28.3755C24.3389 28.3755 23.541 29.1734 23.541 30.1576C23.541 31.1418 24.3389 31.9397 25.3231 31.9397Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.785 37.6401C19.7693 37.6401 20.5672 36.8423 20.5672 35.858C20.5672 34.8738 19.7693 34.0759 18.785 34.0759C17.8008 34.0759 17.0029 34.8738 17.0029 35.858C17.0029 36.8423 17.8008 37.6401 18.785 37.6401Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26551 31.8318C7.24974 31.8318 8.04762 31.0339 8.04762 30.0497C8.04762 29.0655 7.24974 28.2676 6.26551 28.2676C5.28128 28.2676 4.4834 29.0655 4.4834 30.0497C4.4834 31.0339 5.28128 31.8318 6.26551 31.8318Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9844 17.6185V15.9557",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8237 19.3949C6.92426 19.3949 6.9735 19.3949 6.73109 19.3949C2.62902 19.3949 0.666992 17.4443 0.666992 14.2247C0.666992 10.9578 3.17823 8.87461 5.53986 8.87461C5.77848 8.87461 6.01143 8.89545 6.23869 8.93143C6.22354 8.76667 6.21596 8.59811 6.21596 8.42956C6.21596 5.25926 8.78591 2.68742 11.9581 2.68742C13.4296 2.68742 14.7724 3.24231 15.7894 4.15325C17.1321 2.24615 19.3536 1 21.8648 1C24.7832 1 27.3077 2.68363 28.5236 5.13048C28.9667 4.93541 29.4554 4.82746 29.9705 4.82746C31.9609 4.82746 33.5726 6.44102 33.5726 8.42956C33.5726 8.44282 33.5726 8.45418 33.5707 8.46744C37.0913 8.46744 39.3337 11.1415 39.3337 14.2702C39.3337 17.2132 36.8811 19.393 33.3624 19.393C33.2146 19.393 30.4496 19.393 29.2073 19.393",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5722 8.46936C32.8015 8.46936 31.4606 8.82351 30.8262 9.49393",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7872 4.1532C14.8232 5.60388 14.8232 7.05457 14.8232 7.05457",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23828 8.9314C7.83101 9.1776 8.61506 9.9465 8.61506 9.9465",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5227 5.13037C27.8182 5.35763 27.3145 5.8614 27.3145 5.8614",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergyConsume);
export default __webpack_public_path__ + "static/media/icon-energy-consume.bad1e4faa387a4bcbbaffced7acf5301.svg";
export { ForwardRef as ReactComponent };